import { render, staticRenderFns } from "./TouristTabBar.vue?vue&type=template&id=7fec6f73&scoped=true&"
import script from "./TouristTabBar.vue?vue&type=script&lang=js&"
export * from "./TouristTabBar.vue?vue&type=script&lang=js&"
import style0 from "./TouristTabBar.vue?vue&type=style&index=0&id=7fec6f73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fec6f73",
  null
  
)

export default component.exports